import React from "react";
import Loader from "../Components/Loader";
import { Suspense, lazy } from "react";
// import { Nav } from '../Components/Nav'
// import image from '../assets/Mask group.png'
// import { About } from "./About";


// import { Footer } from '../Components/Footer'
const Hero = lazy(() => import("../Components/Hero"));


const Home = () => {
  //   const [isLoading, setIsLoading] = useState(true);
  //   useEffect(() => {
  //     setTimeout(() => {
  //       setIsLoading(false);
  //     }, 3000);
  //   }, []);
  return (
    <>
      <Suspense fallback={<Loader />}>
        <div className="bg[#f8f8f9] overflow-hidden">
          <Hero />
          
        </div>
      </Suspense>
    </>
  );
};
export default Home;
